<div class="m-[57px]">
  <h1 class="text-[32px] font-bold">
    Gradebook
  </h1>
  <div class="mt-[21px] flex items-center justify-between">
    <div class="flex items-center gap-[12px]">
      <div class="bg-[#FFF] w-[312px] h-[48px] flex items-center border border-[#BFC7CE] rounded-[8px]">
        <fa-icon [icon]="faMagnifyingGlass" class="mr-[12px] ml-[18px]" />
        <input class=".placeholder-[#586674] bg-transparent !outline-none flex-grow h-full" [(ngModel)]="searchText" placeholder="Search" />
      </div>
      <button class="py-[10px] px-[16px] transition rounded-[8px] border border-[#D0D5DD] bg-[#FFF] shadow-xs text-[#344054] text-[14px] flex font-semibold hover:border-[#718293] hover:bg-[#D6DBE0]">
        <svg xmlns="http://www.w3.org/2000/svg" class="mr-[8px]" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M5 10H15M2.5 5H17.5M7.5 15H12.5" stroke="#344054" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Filters
      </button>
    </div>
    <div class="flex items-center">
      <div class="font-semibold text-[16px] mr-[12px]">
        Assessment Type:
      </div>
      <div>
        <button (click)="showAssessmentTypeDropdown = !showAssessmentTypeDropdown" class="flex text-[16px] justify-between border rounded-[8px] border-[#BFC7CE] bg-[#FFF] px-[18px] py-[12px] w-[196px] hover:border-[#718293] hover:bg-[#D6DBE0]">
          {{assessmentTypeSelected}}
          <fa-icon [icon]="faChevronDown" />
        </button>
        @if (showAssessmentTypeDropdown) {
          <div class="assessmentTypeDropdown">
            <button (click)="switchAssessmentTypeSelected(AssessmentTypes.all_types)" class="hover:bg-[#FBEBEF] w-full flex items-center py-[6px] pl-[12px] group">
              @if (assessmentTypeSelected === AssessmentTypes.all_types) {
                <svg class="mr-[10px]" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <rect width="18" height="18" rx="9" fill="#CC0033"/>
                  <circle cx="9" cy="9" r="4" fill="white"/>
                </svg>
              }
              @if (assessmentTypeSelected !== AssessmentTypes.all_types) {
                <div class="rounded-full mr-[10px] w-[18px] h-[18px] border-[1.5px] border-[#818181] group-hover:border-[#C03]"></div>
              }
              {{AssessmentTypes.all_types}}
            </button>
            <button (click)="switchAssessmentTypeSelected(AssessmentTypes.exam)" class="hover:bg-[#FBEBEF] w-full flex items-center py-[6px] pl-[12px] group">
              @if (assessmentTypeSelected === AssessmentTypes.exam) {
                <svg class="mr-[10px]" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <rect width="18" height="18" rx="9" fill="#CC0033"/>
                  <circle cx="9" cy="9" r="4" fill="white"/>
                </svg>
              }
              @if (assessmentTypeSelected !== AssessmentTypes.exam) {
                <div class="rounded-full mr-[10px] w-[18px] h-[18px] border-[1.5px] border-[#818181] group-hover:border-[#C03]"></div>
              }
              {{AssessmentTypes.exam}}
            </button>
            <button (click)="switchAssessmentTypeSelected(AssessmentTypes.quiz)" class="hover:bg-[#FBEBEF] w-full flex items-center py-[6px] pl-[12px] group">
              @if (assessmentTypeSelected === AssessmentTypes.quiz) {
                <svg class="mr-[10px]" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <rect width="18" height="18" rx="9" fill="#CC0033"/>
                  <circle cx="9" cy="9" r="4" fill="white"/>
                </svg>
              }
              @if (assessmentTypeSelected !== AssessmentTypes.quiz) {
                <div class="rounded-full mr-[10px] w-[18px] h-[18px] border-[1.5px] border-[#818181] group-hover:border-[#C03]"></div>
              }
              {{AssessmentTypes.quiz}}
            </button>
            <button (click)="switchAssessmentTypeSelected(AssessmentTypes.homework)" class="hover:bg-[#FBEBEF] w-full flex items-center py-[6px] pl-[12px] group">
              @if (assessmentTypeSelected === AssessmentTypes.homework) {
                <svg class="mr-[10px]" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <rect width="18" height="18" rx="9" fill="#CC0033"/>
                  <circle cx="9" cy="9" r="4" fill="white"/>
                </svg>
              }
              @if (assessmentTypeSelected !== AssessmentTypes.homework) {
                <div class="rounded-full mr-[10px] w-[18px] h-[18px] border-[1.5px] border-[#818181] group-hover:border-[#C03]"></div>
              }
              {{AssessmentTypes.homework}}
            </button>
          </div>
        }
      </div>
      <!--<button class="bg-[#CC0033] ml-[16px] rounded-[8px] text-white px-[16px] py-[12px] flex hover:bg-[#940025]">
        <svg xmlns="http://www.w3.org/2000/svg" class="mr-[8px]" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M3 3H10.5945V4.5H4.5V19.5H19.5V13.5H21V21H3V3ZM14.9535 3.12H21.018V9H19.518V5.682L12.4125 12.7875L11.352 11.727L18.4575 4.6215H14.9535V3.12Z" fill="white"/>
        </svg>
        Export
        <svg xmlns="http://www.w3.org/2000/svg" class="ml-[8px]" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.707 15.7071C12.5194 15.8946 12.2651 15.9999 12 15.9999C11.7348 15.9999 11.4805 15.8946 11.293 15.7071L5.63598 10.0501C5.54047 9.95785 5.46428 9.84751 5.41188 9.7255C5.35947 9.6035 5.33188 9.47228 5.33073 9.3395C5.32957 9.20672 5.35487 9.07504 5.40516 8.95215C5.45544 8.82925 5.52969 8.7176 5.62358 8.6237C5.71747 8.52981 5.82913 8.45556 5.95202 8.40528C6.07492 8.355 6.2066 8.32969 6.33938 8.33085C6.47216 8.332 6.60338 8.35959 6.72538 8.412C6.84739 8.46441 6.95773 8.54059 7.04998 8.6361L12 13.5861L16.95 8.6361C17.1386 8.45394 17.3912 8.35315 17.6534 8.35542C17.9156 8.3577 18.1664 8.46287 18.3518 8.64828C18.5372 8.83369 18.6424 9.0845 18.6447 9.3467C18.6469 9.60889 18.5461 9.8615 18.364 10.0501L12.707 15.7071Z" fill="white"/>
        </svg>
      </button>-->
    </div>
  </div>
  <div class="mt-[26px] grid grid-cols-6 text-[12px] font-bold text-[#666E7D] px-[16px] uppercase bg-[#F4F6F8] rounded-[4px] h-[48px]">
    <div class="flex items-center ml-[48px] col-span-2">
      Assessment Name
    </div>
    <div class="flex items-center">
      Type
    </div>
    <div class="flex items-center">
      Score
    </div>
    <div class="flex items-center">
      Submission date
    </div>
    <div>
    </div>
  </div>
  @for (grade of myGrades; track grade) {
    <div class="grid grid-cols-6 rounded-[4px] h-[48px] px-[16px] text-[14px] text-[#666E7D] py-[8px]">
      <div class="flex items-center ml-[48px] col-span-2">
        {{grade.exam_title}}
      </div>
      <div class="flex items-center">
        {{grade.type}}
      </div>
      <div class="flex items-center">
        {{grade.final_score}}
      </div>
      <div class="flex items-center">
        {{grade.answer_time | date: 'short'}}
      </div>
      <div>
        <clear-button text="Details" />
      </div>
    </div>
  }
  <full-length-pagination [(currentPagination)]="currentPagination" />
</div>
